export default "__VITE_ASSET__yZjnMsSz__"